<template>
  <layout-list-detail>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-2" v-if="!creatingNew">
            <AccessibleElSelect
              v-model="form.groupingSelected"
              prop="groupingSelected"
              :options="groupingsForAccessibleSelect"
              :withFormItem="true"
              id-prefix="values"
              @change="onChangeGroupingSelected"
            >
              <template slot="label">{{$t('grouping.groups_created')}}</template>
            </AccessibleElSelect>
          </div>

          <div class="lg:mb-2" v-if="creatingNew">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('grouping.nombre')}}
                <el-form-item prop="nombre">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.nombre"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>
        </el-form>
    </div>
    </template>
    <template slot="table-header" v-if="selectedGroup && !creatingNew">
      <div class="w-full md:w-11.5/12 lg:max-w-detail lg:mr-auto">
        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('grouping.values_by_group')}}</label>
        <el-table
          ref="groupingvaluestable"
          :data="ListaValores"
          style="width: 100%"
          :show-header="false">
          <el-table-column
            prop="Nombre"
            label="Nombre"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="actions"
            width="80"
            align="center"
            label="-">
            <template slot-scope="scope">
            <div class="flex flex-row">
              <base-button-icon @click="deleteListaValores(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar valor"/>
            </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive v-if="creatingNew" mode="secondary" :text="$t('app.cancel')" icon="cross" @click="cancelCreating" :loading="isGeneralLoading"/>
          <base-button-responsive v-else mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="creatingNew" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>

          <!-- <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('configurations.add_value')" icon='plus' @click='newListaValoresToggleDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('app.import_values')" icon='import' @click='toggleImportListaValores' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('groups.duplicate')" icon='copy' @click='toggleDuplicateDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('app.edit_name')" icon='editpencil' @click='toggleEditNameDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('grouping.delete')" icon='trash' @click='toggleDeleteDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/> -->

          <base-table-select-actions-form 
            ref="baseTableSelectActionsFormGrouping"
            v-if="actions && actions.length > 0 && selectedGroup && !creatingNew"
            :baseDropDownVisible="actions.length > 0">
            <template slot="more">
              <span v-for="action in actions" :key="action.IdAccion">
                <base-button-item-list theme="dark" 
                  @click="handleAction(action)" 
                  :disabled="isGeneralLoading" 
                  :loading="isGeneralLoading">
                  <base-icon :name="action.Icono" class="mr-2" :ariaHidden="true"/>
                  <div class="w-72 text-left">
                    {{ action.Descripcion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>
      
          <base-button-responsive v-if="!creatingNew" mode='primary' :text="$t('app.import_groupings')" icon='import' @click='toggleImportGroupingValues' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="!creatingNew" mode="primary" :text="$t('grouping.new_group')" icon="plus" @click="resetViewNew" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <import-generic-dialog
        :dialogOpen="showModalImportGroupingValues"
        @toggleDialog="toggleImportGroupingValues"
        @applyDialog="applyImportGroupingValues"
        @downloadTemplate="downloadTemplateGroupingValues"
        header="Importación de Agrupaciones de valores" 
        :getClientActive="false"
        />
      <BaseElDialog
        title="Borrar agrupación"
        :visible.sync="showModalDelete"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-grouping')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-grouping">
            <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModalDelete = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <input-text-dialog 
        :dialogOpen="showModalEditName" 
        @toggleDialog="toggleEditNameDialog" 
        @applyDialog="applyEditName"
        :header="$t('app.edit_name')"
        headerValue="Nuevo nombre de la agrupación" 
        />
      <input-text-dialog 
        :dialogOpen="showModalDuplicate" 
        @toggleDialog="toggleDuplicateDialog" 
        @applyDialog="applyDuplicateGrouping"
        header="Duplicar agrupación" 
        headerValue="Nombre de la nueva agrupación" 
        />
      <input-text-dialog 
        :dialogOpen="showModalNew" 
        @toggleDialog="newListaValoresToggleDialog" 
        @applyDialog="applyNewListaValoresToggleDialog"
        header="Añadir nuevo valor a la agrupación" 
        headerValue="Nuevo valor de texto"
        />
      <import-generic-dialog
        :dialogOpen="showModalImport" 
        @toggleDialog="toggleImportListaValores" 
        @applyDialog="applyImportListaValores"
        @downloadTemplate="downloadTemplateListaValores"
        :getClientActive="false"
        header="Importación de Valores"
        />
    </template>
  </layout-list-detail>
</template>

<script>
import { bus } from '@/main'

import LayoutListDetail from '@/components/layout/DetailListLayout.vue'
import InputTextDialog from '@/components/InputTextDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

import { downloadGroupingValuesExcel } from '@/services/configurations/grouping/downloadGroupingValuesExcel'

import { newGroupingValues } from '@/services/configurations/grouping/newGroupingValues'
import { updateGroupingValues } from '@/services/configurations/grouping/updateGroupingValues'
import { deleteGroupingValues } from '@/services/configurations/grouping/deleteGroupingValues'
import { duplicateGroupingValues } from '@/services/configurations/grouping/duplicateGroupingValues'
import { getAgrupacionesSimpleValues } from '@/services/configurations/grouping/getAgrupacionesSimpleValues' 
import { getAgrupacionesListaValues } from '@/services/configurations/grouping/getAgrupacionesListaValues'  
import { deleteValorAgrupacionValores } from '@/services/configurations/grouping/deleteValorAgrupacionValores'  
import { addValorAgrupacionValores } from '@/services/configurations/grouping/addValorAgrupacionValores'  
import { downloadTemplateValoresMetadato } from '@/services/configurations/imports/downloadTemplateValoresMetadato'
import { importValoresTexto } from '@/services/configurations/imports//importValoresTexto'

import BaseElDialog from '@/components/base/BaseElDialog.vue'
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { importGroupingValues } from '@/services/configurations/imports/importGroupingValues'
import { downloadTemplateGroupingValues } from '@/services/configurations/imports/downloadTemplateGroupingValues'

export default {
  /* eslint-disable camelcase */
  name: 'grouping-values-view',
  components: {
    // ListLayout,
    LayoutListDetail,
    BaseElDialog,
    InputTextDialog,
    ImportGenericDialog,
    AccessibleElSelect,
  },
  data: function () {
    return {
      creatingNew: false,
      // All
      showModalImport: false,
      showModalNew: false,
      showModalDelete: false,
      showModalEditName: false,
      showModalDuplicate: false,
      loadingExcel: false,
      linkGroupingLocationsDialog: false,
      searchView: false,
      activeName: 'es',
      spanish: true,
      header: {
        title: 'DETALLE DE AGRUPACIONES',
        icon: 'config',
        breadcrumb: null,
        url: 'configurations'
      },
      groupings: [],
      ListaValores: [],
      showModalImportGroupingValues: false,
      form: {
        nombre: '',
        groupingSelected: null,
      },
      rules: {
        nombre: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ]
      },
      processMessage: '¿Estás seguro que deseas borrar la agrupación actual?'
    }
  },
  computed: {
    actions () {
      let res = []
      if (this.selectedGroup && !this.creatingNew) {
        res = [
          { IdAccion: 1, Descripcion: this.$i18n.t('configurations.add_value'), Icono: 'plus', Accion: this.newListaValoresToggleDialog },
          { IdAccion: 2, Descripcion: this.$i18n.t('app.import_values'), Icono: 'import', Accion: this.toggleImportListaValores },
          { IdAccion: 3, Descripcion: this.labelBtnExcel, Icono: 'excelxls', Accion: this.exportExcel },
          { IdAccion: 4, Descripcion: this.$i18n.t('groups.duplicate'), Icono: 'copy', Accion: this.toggleDuplicateDialog },
          { IdAccion: 5, Descripcion: this.$i18n.t('app.edit_name'), Icono: 'editpencil', Accion: this.toggleEditNameDialog },
          { IdAccion: 6, Descripcion: this.$i18n.t('grouping.delete'), Icono: 'trash', Accion: this.toggleDeleteDialog },
        ]
      }
      return res
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    selectedGroup () {
      return this.form.groupingSelected
    },
    labelBtnExcel: function () {
      return this.$i18n.t('app.export_excel')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isCreate: function () {
      return parseInt(this.$route.params.id) === -1
    },
    clienteId () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : null
    },
    isSuperAdminView () {
      return this.clienteId
    },
    paramClientId () {
      return this.isSuperAdminView ? { idCliente: this.clienteId } : null
    },
    groupingsForAccessibleSelect () {
      return this.groupings.map(grouping => ({
        id: grouping.idAgrupacion,
        name: grouping.Nombre,
        value: grouping.idAgrupacion
      }))
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    // console.log('created: ')
  },
  mounted: async function () {
    const breadcrumbs = []
    if (this.isSuperAdminView) {
      breadcrumbs.push({
        path: 'configurations/clients/details',
        name: this.$i18n.t('app.client')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }

    await this.downloadData()
    breadcrumbs.push({ 
      path: this.isSuperAdminView ? 'configurations/grouping/values' : 'configurations/grouping/values/main', 
      name: this.$i18n.t('grouping.grouping_values') 
    })
    this.header.url = this.isSuperAdminView ? 'configurations/clients/details' : 'configurations'
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    handleAction (action) {
      try {
        action.Accion.call(this)
      } catch (error) {
        this.doFeedback()
        console.error(error)
      }
    },
    toggleImportGroupingValues () {
      this.showModalImportGroupingValues = !this.showModalImportGroupingValues
    },
    applyImportGroupingValues: async function (file, form) {
      this.applyGenericImport(file, form, importGroupingValues, this.toggleImportGroupingValues)
    },
    applyGenericImport: async function (file, form, importFunction, toggleFunction) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importFunction(file, { idCliente: this.clienteId })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          toggleFunction() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateGeneric: async function (downloadFunction, nameFile = 'plantilla.xlsx') {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadFunction()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, nameFile)
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateGroupingValues: async function () {
      this.downloadTemplateGeneric(downloadTemplateGroupingValues, 'plantilla-importacion-agrupaciones-valores.xlsx')
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    downloadTemplateListaValores: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateValoresMetadato()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-agrupacion-valores-texto.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportListaValores: async function (file) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importValoresTexto(file, { idAgrupacion: this.selectedGroup })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportListaValores() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleImportListaValores () {
      this.showModalImport = !this.showModalImport
    },
    applyNewListaValoresToggleDialog: async function (valor) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Valor: valor, idAgrupacion: this.selectedGroup }
        const response = await addValorAgrupacionValores(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newListaValoresToggleDialog()
          this.downloadDataGrouping()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const params = {
        idAgrupacion: this.selectedGroup,
      }
      try {
        const response = await downloadGroupingValuesExcel(params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'agrupacion-valores.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    newListaValoresToggleDialog () {
      this.showModalNew = !this.showModalNew
    },
    deleteListaValores: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { valor: row.Nombre, idAgrupacion: this.selectedGroup }
        const response = await deleteValorAgrupacionValores(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadDataGrouping()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onChangeGroupingSelected () {
      if (this.selectedGroup) this.downloadDataGrouping()
    },
    toggleEditNameDialog () {
      this.showModalEditName = !this.showModalEditName
    },
    toggleDuplicateDialog () {
      this.showModalDuplicate = !this.showModalDuplicate
    },
    resetViewNew () {
      this.creatingNew = true
      // this.form.groupingSelected = null
    },
    cancelCreating () {
      this.creatingNew = false
      this.resetFormVal()
      this.downloadData()
    },
    downloadData: async function (idAgrupToSelect = null) {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getAgrupacionesSimpleValues(this.paramClientId)
        if (res.blnError === true) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.groupings = res.Respuesta
          // Preseleccionamos el primero
          if (res.Respuesta.length > 0) {
            this.form.groupingSelected = idAgrupToSelect || res.Respuesta[0].idAgrupacion
            this.onChangeGroupingSelected()
          } else {
            this.form.groupingSelected = null
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadDataGrouping: async function () {
      this.ListaValores = []
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getAgrupacionesListaValues({ idAgrupacion: this.selectedGroup, idCliente: this.clienteId })
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.ListaValores = res.Respuesta.map(x => {
            return { Nombre: x }
          })
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    submitForm: function (formName) {
      this.newGroupingValuesHandler(formName)
    },
    resetForm: function () {
      this.form.nombre = ''
    },
    applyDuplicateGrouping: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { nombre: nombre, idAgrupacion: this.form.groupingSelected }
        const response = await duplicateGroupingValues(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.toggleDuplicateDialog()
          this.downloadData(response.Respuesta)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newGroupingValuesHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            Nombre: this.form.nombre,
            idCliente: this.clienteId
          }
          const response = await newGroupingValues(params)
          if (response.blnError) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Creado correctamente', 'success')
            this.redirectAfterCreating(response.Respuesta)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    redirectAfterCreating (idNewGrouping) {
      this.creatingNew = false
      this.resetForm()
      this.resetFormVal()
      this.downloadData(idNewGrouping)
    },
    resetFormVal () {
      this.$refs.ruleForm.resetFields()
    },
    applyEditName: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          NombreNuevo: nombre,
          idAgrupacion: this.form.groupingSelected,
          idCliente: this.clienteId
        }
        const response = await updateGroupingValues(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Actualizado correctamente', 'success')
          this.toggleEditNameDialog()
          this.downloadData(this.form.groupingSelected)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDeleteDialog () {
      this.showModalDelete = !this.showModalDelete
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idAgrupacion: this.form.groupingSelected,
        }
        const response = await deleteGroupingValues(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Borrado correctamente', 'success')
          this.downloadData()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      if (this.isSuperAdminView) this.$router.push({ name: 'configurations/clients/details' })
      else this.$router.push({ name: 'configurations' })
    },
    toggleDialogs: function () {
      this.linkGroupingLocationsDialog = !this.linkGroupingLocationsDialog
    },
    // linkHandler: async function (sedes) {
    //   try {
    //     this.$store.commit('setIsLoading', true)
    //     const payload = { idAgrupacion: this.form.groupingSelected, idPGNs: sedes }
    //     const response = await linkGroupingLocations(payload)
    //     if (response.blnError === true) {
    //       this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
    //     } else {
    //       this.doFeedback('Vinculado correctamente', 'success')
    //       this.golinkGroupingLocations()
    //     }
    //   } catch (error) {
    //     this.doFeedback()
    //   } finally {
    //     this.$store.commit('setIsLoading', false)
    //   }
    // },
  }
}
</script>
